import React, { useState } from 'react';
import { useTranslate } from 'react-redux-multilingual';
import { ExportArticleButton } from '@gull';
import { Modal } from "react-bootstrap";

const BtnExportPeriod = (props) => {
    const t = useTranslate();
    const [show, setShow] = useState(false);
    const [valueInput, setValueInput] = useState({ begin: '', end: '' });

    let initFiltre = props.hasOwnProperty('filtre') ? props.filtre : {};
    let filtre = { ...initFiltre, ...valueInput };

    const handleChange = (e, name) => {
        setValueInput({ ...valueInput, [name]: e.target.value });
    };

    return (
        <>
            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='form-group row'>
                        <div className='form-group col-6'>
                            <label>{t('beginningPeriod')}</label>
                            <input value={valueInput.begin} type="date" className='form-control' onChange={(e) => handleChange(e, 'begin')} />
                        </div>
                        <div className='form-group col-6'>
                            <label>{t('endPeriod')}</label>
                            <input value={valueInput.end} type="date" className='form-control' onChange={(e) => handleChange(e, 'end')} />
                        </div>
                    </div>
                    {valueInput.begin === '' || valueInput.end === '' ?
                        <button className='btn btn-sm btn-dark' disabled>{props.title}</button>
                        :
                        <div onClick={() => setShow(false)}>
                            <ExportArticleButton
                                filtre={filtre}
                                clientId={props.hasOwnProperty('clientId') ? props.clientId : false}
                                addMark={props.addMark}
                                lang={props.lang}
                                title={props.title}
                                type="button"
                                url={props.url}
                            />
                        </div>
                    }
                </Modal.Body>
            </Modal>
            <button className='btn btn-sm btn-dark mb-2' onClick={() => setShow(true)}>{props.title}</button>
        </>
    );
};

export default BtnExportPeriod;
